import React from "react";
import "./Professional.css";

const Professional = () => {
  const professionalProducts = [
    {
      id: 1,
      name: "Job Portal System",
      description: "Comprehensive recruitment platform connecting employers with qualified candidates.",
      features: [
        "Job posting and management",
        "Candidate search and filtering",
        "Resume database",
        "Application tracking",
        "Interview scheduling",
        "Analytics dashboard"
      ],
      expectations: [
        "Streamlined hiring process",
        "Access to quality talent",
        "Reduced time-to-hire",
        "Improved candidate experience"
      ],
      customization: [
        "Industry-specific portals",
        "Employer branding options",
        "AI-powered matching",
        "Integration with HR systems"
      ]
    },
    {
      id: 2,
      name: "Portfolio Builder for Freelancers",
      description: "Easy-to-use platform for creating stunning professional portfolios to showcase work.",
      features: [
        "Drag-and-drop editor",
        "Customizable templates",
        "Project showcase",
        "Client testimonials",
        "Contact forms",
        "SEO optimization"
      ],
      expectations: [
        "Professional online presence",
        "Increased client inquiries",
        "Easy content updates",
        "Mobile-friendly display"
      ],
      customization: [
        "Domain connection",
        "Custom color schemes",
        "E-commerce integration",
        "Password protection"
      ]
    },
    {
      id: 3,
      name: "Digital Business Card Generator",
      description: "Modern solution for creating and sharing interactive digital business cards.",
      features: [
        "Customizable designs",
        "Contact information sharing",
        "Social media links",
        "Analytics tracking",
        "QR code generation",
        "Instant updates"
      ],
      expectations: [
        "Eliminate paper waste",
        "Real-time contact updates",
        "Enhanced networking",
        "Professional image"
      ],
      customization: [
        "Company branding",
        "Team management",
        "CRM integration",
        "Custom fields"
      ]
    },
    {
      id: 4,
      name: "Document Signing & Verification",
      description: "Secure electronic signature and document verification platform.",
      features: [
        "Legally binding eSignatures",
        "Document templates",
        "Workflow automation",
        "Audit trails",
        "Identity verification",
        "Cloud storage"
      ],
      expectations: [
        "Faster document completion",
        "Reduced paperwork",
        "Compliance with regulations",
        "Secure transactions"
      ],
      customization: [
        "Branded interfaces",
        "Approval workflows",
        "API integrations",
        "Multi-language support"
      ]
    }
  ];

  return (
    <div className="professional-container">
      <div className="professional-header">
        <h1>Professional & Creative Services</h1>
        <p className="subtitle">Specialized tools to enhance your professional services and creative work</p>
      </div>

      <div className="professional-grid">
        {professionalProducts.map((product) => (
          <div key={product.id} className="professional-card">
            <div className="professional-card-header">
              <h2>{product.name}</h2>
              <p className="professional-card-description">{product.description}</p>
            </div>

            <div className="professional-card-details">
              <div className="professional-card-section">
                <h3>Key Features</h3>
                <ul>
                  {product.features.map((feature, index) => (
                    <li key={index}>{feature}</li>
                  ))}
                </ul>
              </div>

              <div className="professional-card-section">
                <h3>What you can Expect</h3>
                <ul>
                  {product.expectations.map((expectation, index) => (
                    <li key={index}>{expectation}</li>
                  ))}
                </ul>
              </div>

              <div className="professional-card-section">
                <h3>Customization Options</h3>
                <ul>
                  {product.customization.map((option, index) => (
                    <li key={index}>{option}</li>
                  ))}
                </ul>
              </div>
            </div>

            {/* <div className="professional-card-footer">
              <button className="professional-demo-button">Request Demo</button>
            </div> */}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Professional;